import Image from "next/legacy/image";
import styles from '../styles/Message.module.css';

export default function Message({
  authorName,
  authorImage,
  content,
  style
}: {
  authorName: string,
  authorImage: string,
  content: (string | JSX.Element)[],
  style?: any
}) {
  return <div className={styles.messageContainer} style={style}>
    <div className={styles.messageAvatar}>
      <Image src={authorImage} unoptimized width={32} height={32} style={{ borderRadius: 16 }} />
    </div>
    <div className={styles.messageBubbleContainer}>
      <div className={styles.messageAuthor}>{authorName}</div>
      {
        content.map((message, index) =>
          <div key={index} className={styles.messageBubble}>
            {message}
          </div>
        )
      }
    </div>
  </div>
}